module.exports = __webpack_public_path__ + "img/background-logo.6b72dda6.svg";